import { useMutation } from '@tanstack/react-query';

import { request, getUrlToBackendApi } from '@shared/services/api';

import { TransactionType, PaginationType } from '@types';

const MUTATION_KEY = ['user', 'transactions'];

const REQUEST_URL = '/my_pm_points_transactions';

type RequestBody = {
	page: number;
};

type ResponseType = {
	data: TransactionType[];
	pagination: PaginationType;
};

const PER_PAGE = 6;

export const useMutationGetActivityHistory = () => {
	const token = localStorage.getItem('auth_token');

	return useMutation<ResponseType, Error, RequestBody>({
		mutationKey: MUTATION_KEY,
		mutationFn: async (body: RequestBody) => {
			const response = await request<ResponseType>({
				method: 'get',
				url: getUrlToBackendApi(REQUEST_URL).href,
				headers: {
					...(token ? { Authorization: `Bearer ${token}` } : {})
				},
				params: {
					...body,
					per_page: PER_PAGE
				}
			});
			return response;
		}
	});
};
